<!-- <hr style="margin-top: 0px; margin-bottom: 0px;"> -->

<div *ngIf="isReadySensorGroups && isReadyAllSensors &&  isReadyAssociatedUserGroups; else loading" class="col-md-12">
  <p-confirmDialog #cd>
    <ng-template #footer>
      <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
      <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
    </ng-template>
  </p-confirmDialog>

  <p-table #sensorGroupTable [columns]="sensorGroupCols" [value]="sensorGroupsDisplayed" sortField="name" [scrollable]="true" scrollHeight="flex">
    <ng-template let-columns pTemplate="header">
      <tr>
        <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
          {{col.header}}
          <!-- <p-sortIcon *ngIf="col.header!='' && col.header!='#Sensors'" [field]="col.field"></p-sortIcon> -->
        </th>
      </tr>
    </ng-template>
    <ng-template let-columns="columns" let-rowData pTemplate="body">
      <tr *ngIf="rowData.userFeatureAccess['ViewListing'] || global.globalSwitch" style="height: 40px;">
        <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
          <div class="css-tooltip2" [attr.tooltip-data]="rowData.id">
            {{rowData.name}}
          </div>
        </td>

        <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
          {{ rowData.description }}
        </td>

        <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
          {{ getOwnerName(rowData) }}
        </td>

        <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
          {{ rowData.crop }}
        </td>

        <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
          {{ rowData.plantAge }}
        </td>

        <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
          {{ getSensorGroupSensorCountDisplay(rowData) }}
        </td>

        <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
          {{ rowData.modifiedDate | date : 'medium' }}
        </td>

        <td class="modifications" [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
          <div *ngIf="rowData.userFeatureAccess['EditSensorGroup']"
              (click)="editSensorGroup(rowData)" aria-hidden="true"
              class="fas fa-pencil-alt text-center" style="color:#64a70b; cursor: pointer; font-size: 14px;">
          </div>
          <div *ngIf="rowData.userFeatureAccess['ViewSensorGroup'] && !rowData.userFeatureAccess['EditSensorGroup']"
              (click)="editSensorGroup(rowData)" aria-hidden="true"
              class="far fa-eye text-center" style="color:#1c4966; cursor: pointer; font-size: 14px;">
          </div>
        </td>

        <td class="modifications" [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
          <div *ngIf="rowData.userFeatureAccess['DeleteSensorGroup']" (click)="onDeleteConfirm(rowData,preSensorGroupDeleteTemplate)" aria-hidden="true"
                  class="far fa-trash-alt text-center" style="color:#c8102e; cursor: pointer; font-size: 14px;">
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template let-columns pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length">
          No search results
        </td>
      </tr>
    </ng-template>
    <ng-template let-rowData pTemplate="caption">
      <div style="text-align: left; display: flex; gap: 1em; align-items: center; margin-bottom: 0px; flex-wrap: wrap;">

        <div style="display: block; width: 170px;">
          <label style="font-size: large; vertical-align: middle; color:black; font-weight: 500;">SENSOR GROUPS</label>
          <div style="display: flex; gap: 8px;" class="text-center">
            <div style="display: block;">
              <div style="font-size: 12px;">Displayed</div>
              <div style="font-size: 12px;">{{ sensorGroupsDisplayed.length }}</div>
            </div>
            <div style="display: block;">
              <div style="font-size: 12px;">Total</div>
              <div style="font-size: 12px;">{{ sensorGroups.length }}</div>
            </div>
          </div>
        </div>

        <div style="text-align: left; display: flex; gap: 10px; align-items: center; min-width: 240px;">
          <form (ngSubmit)="searchSensorGroupsTextChanged()">
              <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchSensorGroupsTextChanged()"></i>
              <i class="fa-solid fa-magnifying-glass-minus" style="margin:4px 4px 0 0; cursor: pointer;" (click)="clearSearchFilter()"></i>
              <input [(ngModel)]="sensorGroupSearch" placeholder="Search" size="25" style="width:auto; height: 35px" type="text" name="sensorGroupSearch" autocomplete="off"/>
          </form>
          <!-- <label style="font-size: 20px; margin-top: -4px;">|</label>
          <label style="font-size: 14px">Searched: {{sensorGroupsDisplayed.length}} of {{sensorGroups.length}}</label>
          <label style="font-size: 20px; margin-top: -4px;">|</label> -->
        </div>
        <button style="float: right; height: 35px; padding-top: 4px;" (click)="addSensorGroup(template)" class="btn btn-success" type="button">Create</button>
        <button style="float: right; height: 35px; padding-top: 4px;" (click)="locateSensorGroup(locateSensorGroupTemplate2)" class="btn btn-primary" type="button">Locate Sensor Group using Sensor UID</button>
        <button style="float: right; height: 35px; padding-top: 4px;" (click)="locateSensorGroupHistoryByName(locateSensorGroupRecentNameTemplate)" class="btn btn-primary" type="button">Locate by Previous Name</button>
        <button style="float: right; height: 35px; padding-top: 4px; margin-right: 5px" (click)="importSensorGroupInfo(importCSVFileTemplate)" class="btn btn-info" type="button">Import</button>
        <span style="border: 1px dotted lightgray; width: 400px; height: 35px; padding-top: 5px; padding-left: 5px; color: #c8102e">{{updatedSensorGroupToDisplay}}</span>
      </div>  

    </ng-template>
  </p-table>
</div>

<ng-template #loading>
  <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 30px 10px 0px 30px;"></i>
    <span>Loading...</span>
  </div>
</ng-template>


<ng-template #preSensorGroupDeleteTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="sensorgroupusage-modal">
  <!-- <div class="modal-content sensorgroupusage-modal"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 style="color: rgb(10, 10, 10); text-transform: none;">Warning: Sensor group in use</h5>
      <button
        (click)="modalRef.hide()"
        class="ms-auto fas fa-times" type="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>
    <br>
    <div class="text-center" style="padding: 20px;">
      <label>
        This sensor group is being referenced by the following Event & Action(s). These Event & Action(s) need to be modified or deleted to not use this sensor group before it can be deleted.
      </label>
    </div>
    <hr>
    <table class="table">
      <tr *ngFor="let event of sensorGroup.events; let i = index">
        <td style="text-align: center;">{{event.name}}</td>
      </tr>
    </table>
    <br>
  </div>
</ng-template>


<ng-template #locateSensorGroupRecentNameTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="locate-modal-namesearch">
  <!-- <div class="modal-content locate-modal-namesearch"> -->

    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Locate Sensor Group by Recent Name</h5>
      <button
        (click)="locatemodalRef.hide()"
        class="ms-auto fas fa-times" type="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>

    <div class="modal-body">
      <div class="container-fluid">
        <div>
          <form #sensorGroupEditor="ngForm" (ngSubmit)="findSensorGroupByRecentName()">
            <div style="margin-left: 5px; margin-top: 10px; display: flex; gap: 0px; align-items: stretch;">
              Search List (comma delimited)
              <button (click)="replaceSearchStringSpacesWithCommas()" class="btn btn-sm btn-primary" style="margin-left: 20px; margin-top: -5px; margin-bottom: 10px;" type="button">Replace Spaces with Commas</button>
            </div>
            <div class="form-group">
              <input #txtElement [(ngModel)]="recentNamesSearchList" class="searchText pull-left" id="SearchInput"
                name="recentNamesSearchList" required type="text" (ngModelChange)="recentNamesSearchListChanged()" />
              <p hidden *ngIf="!searchedRecentNames">{{txtElement.focus()}}</p>
              <button (click)="findSensorGroupByRecentName()" class="btn btn-primary" style="margin-right: 10px; margin-top: -4px" type="button">Find Group</button>
            </div>
          </form>

          <div *ngIf="sensorGroupHistory.length > 0 && searchedRecentNames; else noRecentNamesResults">
            <hr>
            <p-table [columns]="locateByNameCols" [value]="sensorGroupHistory" dataKey="name" [scrollable]="true" scrollHeight="25em" >

              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                  </th>
                </tr>
              </ng-template>
              
              <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                <tr>
                  <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                    <div class="css-tooltip2" [attr.tooltip-data]="rowData.sensorUUIDs">
                      {{ rowData.name }}
                    </div>
                  </td>
                  <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                    {{ rowData.startDate | date : 'medium' }}
                  </td>
                  <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                    {{ rowData.endDate | date : 'medium' }}
                  </td>
                  <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                    {{ rowData.parentName }}
                  </td>
                  <td [ngStyle]="{'width': columns[4].width}" style="flex-wrap: wrap; border-width: 0px; white-space:pre-wrap;">
                    <div *ngFor="let eventName of rowData.associatedEvents; let i = index">
                      {{ eventName }}
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <ng-template #noRecentNamesResults>
            <p *ngIf="searchedRecentNames && sensorGroupHistory.length <= 0">No Results Found</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #locateSensorGroupTemplate2>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="locate-modal">
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Locate Sensor Group by Sensor UID</h5>
      <button
        (click)="locatemodalRef.hide()"
        class="ms-auto fas fa-times" type="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>

    <div class="modal-body">
      <!-- <div class="container-fluid">
        <div> -->
          <form #sensorGroupEditor="ngForm" (ngSubmit)="findSensorGroupsForSensor(searchSensorUUID)">
            <div class="form-group">
              <label style="width:100%">Enter Sensor Info or Scan QR Code</label>
              <input #txtElement [(ngModel)]="searchSensorUUID" class=" searchText pull-left" id="SearchInput"
                name="searchSensorUUID" required type="text" (ngModelChange)="searchSensorUUIDChanged()" />
              <p hidden *ngIf="!searchedSensorUUID">{{txtElement.focus()}}</p>
              <button (click)="findSensorGroupsForSensor(searchSensorUUID)" class="btn btn-primary" style="margin-right: 10px; margin-top: -4px" type="button">Find Group</button>
              <button (click)="openScanModal(scanner)" class="btn btn-warning" style="margin-top: -4px" type="button">Scan</button>

              <ng-template #scanner class="qrScanner" let-modal>
                <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="qr-scanner-modal">
                <!-- <div class="modal-content qr-scanner-modal"> -->
                  <div style="background-color: #548235;  height: 7px;"></div>
                  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
                    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">QR Code Scanner</h5>
                    <button
                      (click)="scanModalRef.hide()"
                      class="ms-auto fas fa-times" type="button"
                      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
                    </button>
                  </div>

                  <div class="modal-body qr-scanner-body">
                    <kig-scanner (scanSuccess)="scanComplete($event)" (camerasFound)="camerasFound($event)" [device]="selectedDevice" id="scanZX"></kig-scanner>
                    <br>
                    <!-- <div class="scanSensor" id="sensorUUID">{{scannedSensor}} </div> -->

                    <select (change)="onDeviceSelectChange($event.target.value)" style="height: 38px; width: 100%;">
                      <option value="" [selected]="!selectedDevice">No Device</option>
                      <option *ngFor="let device of availableDevices"
                          [value]="device.deviceId"
                          [selected]="selectedDevice && device.deviceId === selectedDevice.deviceId">{{ device.label }}
                      </option>
                    </select>

                    <!-- <button (click)="scannedSensorQR()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button">Select</button> -->

                    <div style="display: flex;">
                      <input type="text" [(ngModel)]="scannedSensor" name="sensorUUID" style="width: 280px; height: 35px; margin-left: 0px; margin-top: 20px; margin-right: 20px;" autofocus />
                      <button (click)="scannedSensorQR()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button" style="height: 35px; margin-top: 20px;">Select</button>
                    </div>
                  </div>
                </div>
              </ng-template>

            </div>
          </form>

          <form #sensorGroups="ngForm" (ngSubmit)="updateChangedSensorGroupsAndTriggers()" name="SensorGroupsFound">
            <div *ngIf="sensorGroupsToUpdate.length > 0 && searchedSensorUUID; else noResults">
              <hr>
              <p-table [columns]="locateByIDCols" [value]="sensorGroupsToUpdate" dataKey="name" [scrollable]="true" scrollHeight="25em" >

                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                      {{col.header}}
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                  <tr>
                    
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                      <span *ngIf="!rowData.userFeatureAccess['EditSensorGroupName']">{{rowData.name}}</span>
                      <span *ngIf="rowData.userFeatureAccess['EditSensorGroupName']">
                        <input #pInputText [(ngModel)]="rowData.name" class="searchText" id="{{'I' + rowIndex}}" style="width:100%"
                              name="{{'I' + rowIndex}}" required type="text"
                              onfocus="this.setSelectionRange(0, this.value.length)"
                              (ngModelChange)="sensorGroupNameChanged(rowData)"
                              autofocus 
                              > 
                      </span>
                    </td>

                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;" class="text-center">
                      {{ rowData.sensors.length }}
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex-wrap: wrap; border-width: 0px; white-space:pre-wrap;">
                      <div *ngFor="let event of rowData.events; let i = index" >

                        <span *ngIf="event.userFeatureAccess['EnableEvent']" style="vertical-align: middle;" >
                          <p-toggleswitch id="triggerenable" [ngModel]="!event.isDisabled" (ngModelChange)="event.isDisabled = !$event" [ngModelOptions]="{standalone: true}"
                            (onChange)="triggerEnableChanged(rowData, event)" required>
                          </p-toggleswitch>
                        </span>
                        &nbsp;
                        <label style="text-align: left; vertical-align: middle;" for="triggerenable">{{event.name}}</label>

                      </div>
                    </td>

                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                      <div *ngIf="rowData.userFeatureAccess['EditSensorGroup']"
                            (click)="editSensorGroup(rowData,template)" aria-hidden="true"
                            class="fas fa-pencil-alt text-center" style="color:#64a70b; cursor: pointer; font-size: 14px;">
                      </div>
                    </td>

                  </tr>
                </ng-template>

              </p-table>

              <br>
              <button style="margin-bottom: 10px;"class="btn btn-success col-xs-5 pull-right" type="submit">Update</button>
            </div>

            <ng-template #noResults>
              <p *ngIf="searchedSensorUUID && sensorGroupsToUpdate.length<=0">No Results Found</p>
            </ng-template>
          </form>

        <!-- </div>
      </div> -->
    </div>
  </div>
</ng-template>


<ng-template #importCSVFileTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="importCSV-modal">
  <!-- <div class="modal-content importCSV-modal"> -->
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
          <h5 style="color: rgb(10, 10, 10); text-transform: none;">Bulk Import for New and Updated Sensor Groups</h5>
          <button
          (click)="importModalRef.hide()"
          class="ms-auto fas fa-times" type="button"
          style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
      </div>

      <div class=" modal-body" style="margin-top: -1px;">
        <div style="display: flex; gap: 10px;">
          <div class="form-group" style="width: 650px;">
              <label style="margin-bottom: 10px;" for="file">Please select a comma delimited CSV file using the "Choose File" button. An example header row (showing required and optional column names) is given below.</label>
              <label style="margin-left: 20px; width: 650px;">Header row</label>
              <label style="font-size: 14px; margin-left: 40px; width: 650px; margin-bottom: 20px;">Name, Description, UserGroup, UUIDs, StartDate, EndDate, Action</label>
              <label style="margin-left: 20px; width: 650px;">Notes</label>
              <label style="font-size: 14px; margin-left: 40px; width: 650px;">1. StartDate, EndDate, and Action columns are optional</label>
              <label style="font-size: 14px; margin-left: 40px; width: 650px;">2. All dates must be in given in UTC (example format:  2024-02-14T14:00:00Z)</label>
              <label style="font-size: 14px; margin-left: 40px; width: 650px;">3. UserGroup must be an existing group name</label>
              <label style="font-size: 14px; margin-left: 40px; width: 650px;">4. Multiple UUIDs can be given in the UUIDs column but be separate by ';' (eg. 001;002;003)</label>
              <label style="font-size: 14px; margin-left: 40px; width: 650px; margin-bottom: 25px;">5. Action column can be 'replace', 'add', 'append', or 'delete'. Default is 'replace'</label>
              <input type="file" id="file" accept=".csv" (change)="csvFileSelected($event)">
              <i *ngIf="analyzingCSVFile" style="margin-left: 20px;" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
          </div>
        </div>

        <div *ngIf="readyToImportFileContent">
          <hr>
          <div *ngFor="let result of importCSVFileAnalysisResults">
            {{ result }}
          </div>
          <hr>
          <i *ngIf="importingCSVFileContents" style="margin-right: 20px; float: right;" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
          <button (click)="importCSVFileContent()" class="btn btn-success" style="width: 100px; float: right; margin-bottom: 10px;" type="button">Import</button>  
        </div>

      </div>
  </div>
</ng-template>

